
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7w8ah", function(module, exports) {
var $4b12b330ff8d99c7$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
function $4b12b330ff8d99c7$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    const DEFAULT_POSITION_VALUE = 50;
    try {
        value = JSON.parse(p.value);
        version = p.version ? parseInt(JSON.parse(p.version.number)) : null;
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: DEFAULT_POSITION_VALUE
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
module.exports["CoverPictureIdPropertyKey"] = $4b12b330ff8d99c7$export$da638b84af7eb6eb;
module.exports["propertyToId"] = $4b12b330ff8d99c7$export$da000b5ddbbe9afc;

});

parcelRegister("e51Sk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cUcZ5 = parcelRequire("cUcZ5");


var $inPa6 = parcelRequire("inPa6");


var $lhvsH = parcelRequire("lhvsH");


var $1VNax = parcelRequire("1VNax");

var $4cOi8 = parcelRequire("4cOi8");

var $7q60U = parcelRequire("7q60U");

var $g3LxX = parcelRequire("g3LxX");


var $kcoxM = parcelRequire("kcoxM");


var $5un3P = parcelRequire("5un3P");

const $a2d58ae16516956a$export$669fadbeb0d65b03 = {
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    textColor: "var(--ds-text, #292A2E)"
};
const $a2d58ae16516956a$var$getNewCardImage = (cardsLength)=>{
    const imageIndex = cardsLength % (0, $kcoxM.CARDS_IMAGES_V5).length;
    const { src: src, alt: alt } = (0, $kcoxM.CARDS_IMAGES_V5)[imageIndex] || (0, $kcoxM.CARDS_IMAGES_V5)[0];
    return {
        imageSrc: src,
        imageAltText: alt
    };
};
const $a2d58ae16516956a$export$d4fe2f2056b6479c = (defaultField)=>{
    return {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imagePosition: (0, $5un3P.ImagePosition).MIDDLE,
        ...defaultField
    };
};
const $a2d58ae16516956a$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited, linkResourceType)=>{
    return {
        [(0, $4cOi8.ITEM_FIELDS).LINK]: link,
        [(0, $4cOi8.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $4cOi8.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false,
        [(0, $4cOi8.ITEM_FIELDS).LINK_RESOURCE_TYPE]: linkResourceType || ''
    };
};
const $a2d58ae16516956a$var$fetchLocalIdMacroParameters = (editorActions, localId)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    params = $a2d58ae16516956a$var$migrateParamsToLatestVersion(params);
    return params;
};
/**
 * Migrates card extension parameters to the latest version by applying
 * default values for any missing properties introduced in each version.
 */ const $a2d58ae16516956a$var$migrateParamsToLatestVersion = (params)=>{
    var // Version 2 defaults
    _params, // Version 3 defaults
    _params1, _params2, _params3, // Version 4 defaults
    _params4, _params5, _params6, _params7, _params8, // Version 5 defaults
    _params9, _params10, _params11, _params12;
    (_params = params).renderVariant ?? (_params.renderVariant = (0, $4cOi8.RenderVariant).MANUAL);
    (_params1 = params).isAutoscrollEnabled ?? (_params1.isAutoscrollEnabled = false);
    (_params2 = params).orientation ?? (_params2.orientation = (0, $5un3P.Orientation).STACKED);
    (_params3 = params).alignment ?? (_params3.alignment = (0, $5un3P.Alignment).CENTER);
    if (params.segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL && params.audienceSegmentationGroupIds === undefined) params.audienceSegmentationGroupIds = params.cards[0]?.audienceSegmentationGroupIds;
    (_params4 = params).backgroundColor ?? (_params4.backgroundColor = "var(--ds-surface-overlay, #FFFFFF)");
    (_params5 = params).textColor ?? (_params5.textColor = "var(--ds-text, #292A2E)");
    (_params6 = params).cornerStyle ?? (_params6.cornerStyle = (0, $4cOi8.CornerStyle).ROUNDED);
    (_params7 = params).isSocialStatsShown ?? (_params7.isSocialStatsShown = false);
    (_params8 = params).isIconShown ?? (_params8.isIconShown = false);
    (_params9 = params).layout ?? (_params9.layout = (0, $5un3P.CardsLayout).FLEXIBLE_IMAGE_HEIGHT);
    (_params10 = params).isPaddingEnabled ?? (_params10.isPaddingEnabled = true);
    (_params11 = params).isLabelShown ?? (_params11.isLabelShown = true);
    (_params12 = params).borderColor ?? (_params12.borderColor = (0, $lhvsH.DEFAULT_GRAY_COLOR));
    // Set to latest version
    params.version = (0, $kcoxM.CARDS_EXTENSION_VERSION_5);
    return params;
};
const $a2d58ae16516956a$var$removeProperties = (extensionsPropertiesToRemove, extensionParameters)=>{
    const mutatedParameters = {
        ...extensionParameters
    };
    extensionsPropertiesToRemove.forEach((field)=>{
        delete mutatedParameters[field];
    });
    return mutatedParameters;
};
const $a2d58ae16516956a$var$updateCardInList = (cards, cardId, updatedField)=>cards.map((card)=>{
        if (card.cardId === cardId) return {
            ...card,
            ...updatedField
        };
        return card;
    });
const $a2d58ae16516956a$export$3c876d2ed5ae458e = ({ localId: localId, editorActions: editorActions })=>{
    const [cardsParameters, setExtensionParameters] = (0, $42omo.useState)($a2d58ae16516956a$var$fetchLocalIdMacroParameters(editorActions, localId));
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $g3LxX.useExtensionsActions)();
    const { cards: cards, segmentationTarget: segmentationTarget, isSegmentationShown: isSegmentationShown } = cardsParameters ?? {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const extensionNodeParams = $a2d58ae16516956a$var$fetchLocalIdMacroParameters(editorActions, localId);
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $42omo.useCallback)((newExtensionParameters, options = {})=>{
        setExtensionParameters((prevParams)=>{
            let mutatedFields = {
                ...prevParams
            };
            const fieldsToRemove = [
                ...options?.fieldsToRemove || []
            ];
            if (fieldsToRemove.length > 0) mutatedFields = $a2d58ae16516956a$var$removeProperties(fieldsToRemove, prevParams);
            const updatedParams = {
                ...mutatedFields,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            const success = (0, $7q60U.updateNodeParameters)(editorActions, updatedParams);
            if (!success) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'cardsExtension',
                    action: 'error',
                    actionSubject: 'cardsConfigPanel',
                    attributes: {
                        updatedFields: newExtensionParameters,
                        version: updatedParams.version
                    }
                }
            }).fire();
            return updatedParams;
        });
    }, [
        editorActions,
        createAnalyticsEvent
    ]);
    const addCard = (0, $42omo.useCallback)(()=>{
        const newCard = $a2d58ae16516956a$export$d4fe2f2056b6479c({
            [(0, $4cOi8.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: isSegmentationShown && segmentationTarget === (0, $4cOi8.SegmentationTargets).ALL ? cards[0]?.audienceSegmentationGroupIds : undefined,
            ...$a2d58ae16516956a$var$getNewCardImage(cards.length)
        });
        updateExtensionParams({
            cards: [
                ...(0, $1VNax.checkItems)(cards) || [],
                newCard
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newCard.cardId);
    }, [
        cards,
        segmentationTarget,
        isSegmentationShown,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const removeCard = (0, $42omo.useCallback)((cardId)=>updateExtensionParams({
            cards: cards.filter((card)=>card.cardId !== cardId)
        }), [
        cards,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $42omo.useCallback)((updatedFields, options = {})=>updateExtensionParams(updatedFields, options), [
        updateExtensionParams
    ]);
    const updateCardFormField = (0, $42omo.useCallback)((cardId, updatedField)=>{
        const updatedCards = $a2d58ae16516956a$var$updateCardInList(cards, cardId, updatedField);
        updateExtensionParams({
            cards: updatedCards
        });
    }, [
        cards,
        updateExtensionParams
    ]);
    const updateCardFormFieldForAllCards = (0, $42omo.useCallback)((updatedField)=>{
        const updatedCards = cards.map((card)=>{
            return {
                ...card,
                ...updatedField
            };
        });
        updateExtensionParams({
            cards: updatedCards
        });
    }, [
        cards,
        updateExtensionParams
    ]);
    const updateLayout = (0, $42omo.useCallback)((newLayout)=>{
        updateExtensionParams({
            layout: newLayout
        });
    }, [
        updateExtensionParams
    ]);
    const updateBorderColor = (0, $42omo.useCallback)((newBorderColor)=>{
        updateExtensionParams({
            borderColor: newBorderColor
        });
    }, [
        updateExtensionParams
    ]);
    const updateCornerStyle = (0, $42omo.useCallback)((newCornerStyle)=>{
        updateExtensionParams({
            cornerStyle: newCornerStyle
        });
    }, [
        updateExtensionParams
    ]);
    const cardsActions = (0, $42omo.useMemo)(()=>({
            addCard: addCard,
            removeCard: removeCard,
            updateMainFormField: updateMainFormField,
            updateCardFormField: updateCardFormField,
            updateCardFormFieldForAllCards: updateCardFormFieldForAllCards,
            updateLayout: updateLayout,
            updateBorderColor: updateBorderColor,
            updateCornerStyle: updateCornerStyle
        }), [
        addCard,
        removeCard,
        updateMainFormField,
        updateCardFormField,
        updateCardFormFieldForAllCards,
        updateLayout,
        updateBorderColor,
        updateCornerStyle
    ]);
    return {
        cardsParameters: cardsParameters,
        cardsActions: cardsActions
    };
};
module.exports["cardNewParametersV4"] = $a2d58ae16516956a$export$669fadbeb0d65b03;
module.exports["createNewCardWithDefaultParameters"] = $a2d58ae16516956a$export$d4fe2f2056b6479c;
module.exports["updateLinkAndConfluencePageId"] = $a2d58ae16516956a$export$721510bd2cdb9b4f;
module.exports["useCardsExtensionParametersAndActions"] = $a2d58ae16516956a$export$3c876d2ed5ae458e;

});

parcelRegister("bGmGb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eXmBZ = parcelRequire("eXmBZ");


var $auNCB = parcelRequire("auNCB");

var $iXCQx = parcelRequire("iXCQx");


var $cgtv4 = parcelRequire("cgtv4");

const $598d867c4680f9f5$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    disclaimerMessage: {
        id: "company-hub.cards-extension.ai-disclaimer.disclaimer-message",
        defaultMessage: "AI generated content"
    }
});


const $e96164e2c3666e0d$var$styles = {
    anchor: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _4cvr1h6o _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
};
const $e96164e2c3666e0d$export$ddd36803697578b9 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const disclaimerMessage = formatMessage((0, $598d867c4680f9f5$export$defe85febe8b728c).disclaimerMessage);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        xcss: $e96164e2c3666e0d$var$styles.anchor,
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtlest",
                children: disclaimerMessage
            })
        ]
    });
};
module.exports["CardsAIDisclaimer"] = $e96164e2c3666e0d$export$ddd36803697578b9;

});

parcelRegister("hG3yD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k00oi = parcelRequire("k00oi");


var $dh538 = parcelRequire("dh538");


var $3kSzn = parcelRequire("3kSzn");

const $d66d87546120ab7b$var$isEmpty = (s)=>!s || s.trim() === '';
const $d66d87546120ab7b$export$5af1f6d040dd2f99 = (link, imageSrc)=>{
    const [resolvedUrl, setResolvedUrl] = (0, $42omo.useState)(undefined);
    const shouldRefetch = $d66d87546120ab7b$var$isEmpty(imageSrc) && !!link && (0, $3kSzn.isLoomLink)(link) && (0, $dh538.fg)('private-loom-thumbnail-support-on-hub');
    (0, $42omo.useEffect)(()=>{
        if (!shouldRefetch || !link) {
            setResolvedUrl(undefined);
            return;
        }
        let cancelled = false;
        const client = new (0, $k00oi.default)();
        client.fetchData(link).then((data)=>{
            if (cancelled) return;
            const url = data?.data?.image?.url;
            if (url) setResolvedUrl(url);
        }).catch(()=>{
        // Ignore fetch errors; component will show no image
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        link,
        shouldRefetch
    ]);
    if (!(0, $dh538.fg)('private-loom-thumbnail-support-on-hub')) return imageSrc;
    if (!$d66d87546120ab7b$var$isEmpty(imageSrc)) return imageSrc;
    if (shouldRefetch) return resolvedUrl;
    return undefined;
};
module.exports["useLoomThumbnailUrl"] = $d66d87546120ab7b$export$5af1f6d040dd2f99;

});

parcelRegister("3kSzn", function(module, exports) {
/**
 * Returns true when url is a Loom CDN thumbnail that includes a signed Policy
 * (and thus expires). Such URLs should not be stored in ADF.
 * Public loom URLs do not include a Policy.
 */ const $ef0d4a87f331473a$export$e9af613851c565cf = (url)=>{
    return typeof url === 'string' && url.includes('cdn.loom.com') && url.includes('Policy');
};
const $ef0d4a87f331473a$export$fbf81d5b14dce964 = (link)=>{
    if (typeof link !== 'string' || !link) return false;
    try {
        const host = new URL(link).hostname.toLowerCase();
        return (host === 'loom.com' || host === 'www.loom.com') && link.includes('/share/');
    } catch  {
        return false;
    }
};
module.exports["isPrivateLoomImageUrl"] = $ef0d4a87f331473a$export$e9af613851c565cf;
module.exports["isLoomLink"] = $ef0d4a87f331473a$export$fbf81d5b14dce964;

});

parcelRegister("jPFXE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $g3LxX = parcelRequire("g3LxX");


var $evEMm = parcelRequire("evEMm");


var $3VSZJ = parcelRequire("3VSZJ");


var $1A6sR = parcelRequire("1A6sR");


var $5Ac5G = parcelRequire("5Ac5G");


var $eIwIu = parcelRequire("eIwIu");


var $lUiRo = parcelRequire("lUiRo");


var $4cOi8 = parcelRequire("4cOi8");


var $cgtv4 = parcelRequire("cgtv4");

const $0046ac9d98b5de96$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    frameSpotlightLabel: {
        id: "company-hub.carousel-extension.frame-spotlight.label",
        defaultMessage: "frame {positionInSet} of {setSize}"
    }
});


const $6108da5c589e4bad$var$getImage = (src, contentId, alt)=>{
    return src ? /*#__PURE__*/ (0, $l998X.jsx)((0, $evEMm.ImageRenderer), {
        contentId: contentId,
        imageSrc: src,
        imageAlt: alt,
        shouldShowExternalSiteImage: true
    }) : null;
};
const $6108da5c589e4bad$var$styles = {
    frameStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1hu1v2br"
};
const $6108da5c589e4bad$export$d6098952608bbca6 = ({ testId: testId, contentId: contentId, source: source, link: link, title: title, description: description, backgroundColor: // default to neutral color for extensions who don't have this param set yet
// (aka v1 carousels), otherwise BG color will be set to a different default
// upon insertion, when Carousel V2 is enabled
backgroundColor = "var(--ds-background-input, #FFFFFF)", textColor: textColor = (0, $eIwIu.frameNewParametersV2)['textColor'], height: height, layout: layout = (0, $4cOi8.CommonLayout).SPLIT_IMAGE_LEFT, imageData: imageData, imageAltText: imageAltText, width: width, imageWidthPercentage: imageWidthPercentage, buttonStyle: buttonStyle = (0, $eIwIu.frameNewParametersV2)['buttonStyle'], buttonText: buttonText, hasRoundedCorners: hasRoundedCorners, index: index = 0, selectedFrameIndex: selectedFrameIndex = -1, frameSetLength: frameSetLength = 1, extensionLocalId: extensionLocalId })=>{
    const intl = (0, $8C5kA.default)();
    const cardRef = (0, $42omo.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId }] = (0, $g3LxX.useExtensionsState)();
    const resolvedImageData = (0, $lUiRo.useResolveImage)(link, imageData);
    (0, $42omo.useEffect)(()=>{
        if (cardRef.current && selectedFrameIndex === index && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) cardRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        selectedFrameIndex,
        index,
        extensionLocalId,
        selectedExtensionLocalId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($6108da5c589e4bad$var$styles.frameStyles),
        style: {
            width: width,
            minWidth: '100%'
        },
        "aria-label": intl.formatMessage((0, $0046ac9d98b5de96$export$defe85febe8b728c).frameSpotlightLabel, {
            positionInSet: index + 1,
            setSize: frameSetLength
        }),
        ref: cardRef,
        id: `${(0, $5Ac5G.ARIA_CONTROLS_PREFIX)}${extensionLocalId}${index}`,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1A6sR.SpotlightLayout), {
            testId: testId,
            backgroundColor: backgroundColor,
            height: height,
            layout: layout,
            image: $6108da5c589e4bad$var$getImage(resolvedImageData, contentId, imageAltText),
            width: width,
            imageWidthPercentage: imageWidthPercentage,
            hasRoundedCorners: hasRoundedCorners,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3VSZJ.SpotlightContent), {
                title: title,
                description: description,
                layout: layout,
                textColor: textColor,
                isButtonShown: !!link,
                buttonStyle: buttonStyle,
                buttonText: buttonText,
                link: link,
                width: width,
                source: source,
                imageWidthPercentage: imageWidthPercentage
            })
        })
    });
};
module.exports["CarouselLayoutRenderer"] = $6108da5c589e4bad$export$d6098952608bbca6;

});

parcelRegister("lUiRo", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $hG3yD = parcelRequire("hG3yD");

const $127e3ecadf57ff5e$var$hasValidUrl = (s)=>!!s && s.trim() !== '';
const $127e3ecadf57ff5e$export$71956575015d1f5 = (link, imageData)=>{
    const loomThumbnailUrl = (0, $hG3yD.useLoomThumbnailUrl)(link, imageData);
    if (!(0, $dh538.fg)('private-loom-thumbnail-support-on-hub')) return imageData ?? '';
    const hasResolved = $127e3ecadf57ff5e$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $127e3ecadf57ff5e$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? '';
    return '';
};
module.exports["useResolveImage"] = $127e3ecadf57ff5e$export$71956575015d1f5;

});


//# sourceMappingURL=cards-extension.6f03ad46.js.map
